// Leaflet plugins such as `leaflet-boundary-canvas` reference a bare global `L`
// instead of importing leaflet. In a bundled build leaflet does not expose a
// global, so we set it here. This module must be imported BEFORE any leaflet
// plugin so that `window.L` exists when the plugin's IIFE evaluates.
import * as L from 'leaflet';

(window as any).L = L;
